import { useState, useEffect } from "react";
import {
  Box,
  Typography,
  TextField,
  IconButton,
  Tooltip,
  MenuItem,
  Menu,
  InputAdornment,
} from "@mui/material";
import { DataGrid, faIR } from "@mui/x-data-grid";
import { UseFestivalManagment } from "./UseFestivalManagment";
import CustomPagination from "../../components/CustomPagination";
import ProgressCom from "../../components/ProgressCom";
import { deCapitalizeFirstLetter } from "../../util/Utils";
import { rsGotoLast, rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import DeleteIcon from "@mui/icons-material/Delete";
import DeleteRow from "../../components/DeleteRow";
import { UseMyPCDiscount } from "./UseMyPCDiscount";
import AddFestivalDisccount from "./AddFestivalDisccount";
import MoreVertIcon from "@mui/icons-material/MoreVert";

export default function DiscountGrid(props) {
  const [anchorEl, setAnchorEl] = useState(null);
  const openD = Boolean(anchorEl);
  const [searchName, setSearchName] = useState("جستجو همه");
  const [searchState, setSearchState] = useState("");
  const { getFestivalDiscountsByID, deleteFestivalDiscount } =
    UseFestivalManagment();
  const {
    myPcDiscount,
    goToLastPage,
    goToFirstPage,
    updatePage,
    updateSort,
    setScrollTo,
    refresh,
    updatSearchColumn,
  } = UseMyPCDiscount();
  const [msGotoLast, setMsGotoLast] = useRecoilState(rsGotoLast);
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [search, setSearch] = useState("");
  const [discountsRes, setDiscountRes] = useState();
  const [deleteState, setDeleteState] = useState({
    show: false,
    name: undefined,
    id: undefined,
  });

  function handleSearch(value) {
    setScrollTo(undefined);
    setSearch(value);
  }

  useEffect(() => {
    if (myPcDiscount.page === 0) {
      return;
    }
    if (props.festivalID) {
      setProgress(true);

      getFestivalDiscountsByID(
        props.festivalID,
        myPcDiscount,
        search,
        (festivals) => {
          if (msGotoLast) {
            setMsGotoLast(false);
            goToLastPage(festivals.totalPage);
            return;
          }
          setDiscountRes(festivals);
        }
      );
    }
  }, [myPcDiscount, props.festivalID]);

  useEffect(() => {
    if (search.length > 0) {
      goToFirstPage();
    } else {
      refresh();
    }
  }, [search]);

  const columns = [
    {
      field: "rowNO",
      width: 80,
      align: "center",
      headerName: "ردیف",
      headerAlign: "center",
      sortable: false,
    },
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "id",
      headerAlign: "center",
      hide: true,
    },
    {
      field: "title",
      headerName: "عنوان",
      width: 160,
      align: "center",
      headerAlign: "center",
      sortable: false,
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{ whiteSpace: "normal", textAlign: "center" }}
          >
            {cellValues.row.title}
          </Typography>
        );
      },
    },
    {
      field: "objectID",
      headerName: "ID",
      width: 110,
      align: "center",
      headerAlign: "center",
      sortable: false,
    },
    {
      field: "category",
      headerName: "نوع",
      width: 110,
      align: "center",
      headerAlign: "center",
      sortable: false,
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{ whiteSpace: "normal", textAlign: "center" }}
          >
            {cellValues.row.category}
          </Typography>
        );
      },
    },

    {
      field: "discountPercent",
      headerName: "درصد تخفیف",
      width: 100,
      align: "center",
      headerAlign: "center",
    },

    {
      field: "عملیات",
      sortable: false,
      width: 80,
      headerAlign: "center",
      align: "center",
      headerName: "عملیات",
      renderCell: (cellValues) => {
        return (
          <Tooltip title="Delete">
            <IconButton
              sx={{ p: 0.5 }}
              onClick={() => {
                setDeleteState({
                  show: true,
                  name: cellValues.row.category + " " + cellValues.row.title,
                  id: cellValues.row.id,
                });
              }}
            >
              <DeleteIcon fontSize="small" sx={{ color: "MyColor.main" }} />
            </IconButton>
          </Tooltip>
        );
      },
    },
    {
      field: "search",
      width: 300,
      sortable: false,
      headerAlign: "center",
      renderHeader: (cellValues) => {
        return (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              width: 300,
            }}
          >
            <TextField
              sx={{
                "& .MuiInputLabel-root": {
                  fontSize: "0.9rem !important",
                },
              }}
              placeholder={searchName}
              value={searchState}
              onChange={(evt) => {
                if (evt.target.value == "") {
                  handleSearch("");
                }
                setSearchState(evt.target.value);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSearch(searchState);
                }
              }}
              fullWidth
              InputProps={{
                autoComplete: "off",
                inputProps: {
                  min: 1,
                },
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      id="basic-button"
                      aria-controls={openD ? "basic-menu" : undefined}
                      aria-haspopup="true"
                      aria-expanded={openD ? "true" : undefined}
                      onClick={(event) => setAnchorEl(event.currentTarget)}
                      edge="end"
                    >
                      <MoreVertIcon
                        fontSize="small"
                        sx={{ color: "primary.main" }}
                      />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <Menu
              id="basic-menu"
              anchorEl={anchorEl}
              open={openD}
              onClose={() => setAnchorEl(null)}
              MenuListProps={{
                "aria-labelledby": "basic-button",
              }}
              sx={{}}
            >
              <MenuItem
                onClick={() => {
                  setSearchName("جستجو براساس شماره محصول");
                  updatSearchColumn("ProductId");
                  setAnchorEl(null);
                }}
              >
                شماره محصول
              </MenuItem>
              <MenuItem
                onClick={() => {
                  setSearchName("جستجو براساس شماره برند");
                  updatSearchColumn("BrandId");
                  setAnchorEl(null);
                }}
              >
                شماره برند
              </MenuItem>
              <MenuItem
                onClick={() => {
                  setSearchName("جستجو براساس شماره گروه");
                  updatSearchColumn("GroupId");
                  setAnchorEl(null);
                }}
              >
                شماره گروه
              </MenuItem>
            </Menu>
          </Box>
        );
      },
    },
  ];

  return (
    <Box sx={{ height: "30rem" }}>
      {discountsRes ? (
        <DataGrid
          className="ltr-grid"
          localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
          columns={columns}
          pageSize={discountsRes.pageCondition.pageCount}
          rows={discountsRes && discountsRes.items ? discountsRes.items : []}
          paginationMode="server"
          page={discountsRes.pageCondition.page - 1}
          onPageChange={(page) => {
            updatePage(page + 1);
          }}
          rowCount={
            discountsRes?.pageCondition.totalItemCount
              ? discountsRes.pageCondition.totalItemCount
              : 1
          }
          enableRangeSelection={true}
          disableColumnMenu
          hideFooterSelectedRowCount
          components={{
            Pagination: CustomPagination,
          }}
          componentsProps={{
            pagination: {
              nofab: true,
              scrollTo: myPcDiscount.scrollTo,
              isLtr: true,
              rowCount: discountsRes?.pageCondition.totalItemCount
                ? discountsRes.pageCondition.totalItemCount
                : "",
            },
          }}
          initialState={{
            sorting: {
              sortModel: [
                {
                  field: deCapitalizeFirstLetter(myPcDiscount.sortColumn),
                  sort: deCapitalizeFirstLetter(myPcDiscount.sortOrder),
                },
              ],
            },
            pagination: {
              page: myPcDiscount.page,
            },
          }}
          onSortModelChange={(model) => {
            updateSort(model[0].field, model[0].sort == "asc" ? "asc" : "desc");
          }}
          sortingOrder={["desc", "asc"]}
          sortingMode="server"
        />
      ) : (
        <ProgressCom></ProgressCom>
      )}

      <DeleteRow
        deleteState={deleteState}
        setDeleteState={setDeleteState}
        type={"تخفیف"}
        callback={() => {
          setProgress(true);
          deleteFestivalDiscount(deleteState.id, () => {
            refresh();
          });
        }}
      ></DeleteRow>
      <AddFestivalDisccount
        festivalID={props.festivalID}
        callback={() => {
          setProgress(true);
          refresh();
        }}
      />
    </Box>
  );
}
